export default __webpack_public_path__ + "static/media/Skull.853e2432.svg";